export const styles = {
    loading: {
        zIndex: 9999,
        "& .css-spinner": {
            width: "36px",
            height: "36px",
            border: "3px solid #f3f3f3",
            borderTop: "3px solid #000000",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
        },
        "@keyframes spin": {
            "0%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(360deg)" },
        },
    },
};
